import { request } from '@/api/apiUtils';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { IFilters, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const FILTERS_ROOT = ['filters'] as const;

interface FiltersDetailParams {
    projectId: number;
}

const fetchers = {
    detail: {
        key: ({ projectId }: FiltersDetailParams) => [...FILTERS_ROOT, projectId] as const,
        fetch: async ({ projectId }: FiltersDetailParams): Promise<IFilters> => {
            const response: ResponseType<IFilters> = await request(`projects/${projectId}/filters`);
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const filtersEntity: EntityDefinition<typeof fetchers> = {
    name: 'filters',
    roots: [FILTERS_ROOT],
    fetchers,
};
